import React from 'react'
import { User } from '../Shared/common_defs'
import { Box, Loading, Text } from '@workwhile/ui'
import { useUserWorkExperience } from 'queries/user/useUserWorkExperience'
import { format, formatDistance } from 'date-fns'
import { defs } from 'components/Shared/defs'

interface Props {
  user: User
  isOpen?: boolean
}

const MonthYear = 'MMM yyyy'

const formatDuration = ({ startedAt, endedAt }) => {
  const end = endedAt || new Date()
  const duration = formatDistance(startedAt, end, { addSuffix: false })
  return `${format(startedAt, MonthYear)} - ${endedAt ? format(endedAt, MonthYear) : 'current'}, ${duration}`
}

const UserWorkExperience = ({ user, isOpen }: Props) => {
  const { data: workExperience, isFetching } = useUserWorkExperience({
    id: user.id,
    enabled: isOpen,
  })

  return (
    <Box>
      {isFetching ? <Loading /> : null}
      {workExperience?.map((workExperience) => (
        <Box key={workExperience.id} padding={defs.paddingS}>
          <Text fontSize={defs.fontLL}>{workExperience.experience}</Text>
          <Text fontSize={defs.fontDefault} fontWeight={600}>
            {workExperience.companyName}
          </Text>
          <Text fontSize={defs.fontM} color={defs.mediumBlack}>
            {formatDuration(workExperience)}
          </Text>
          <Box>
            {workExperience.skills?.map((skill) => (
              <Text
                key={skill.credentialId}
                flex="0 0 1"
                fontSize={defs.fontDefault}
                fontWeight={
                  ['photo_proof', 'certificate'].includes(
                    skill.verificationType
                  )
                    ? 600
                    : 400
                }
              >
                {' • '}
                {skill.name}
              </Text>
            ))}
          </Box>
        </Box>
      ))}
      {!isFetching && !workExperience?.length && (
        <Text fontSize={defs.fontDefault} color={defs.lightBlack}>
          No work experience
        </Text>
      )}
    </Box>
  )
}

export default UserWorkExperience
